__turbopack_context__.v({
  "cardContent": "use-cases-module__-aw63G__cardContent",
  "cardIcon": "use-cases-module__-aw63G__cardIcon",
  "connectorArrow": "use-cases-module__-aw63G__connectorArrow",
  "mobileSeparator": "use-cases-module__-aw63G__mobileSeparator",
  "problemCard": "use-cases-module__-aw63G__problemCard",
  "realWorldSection": "use-cases-module__-aw63G__realWorldSection",
  "solutionCard": "use-cases-module__-aw63G__solutionCard",
  "useCaseCard": "use-cases-module__-aw63G__useCaseCard",
  "useCasesContainer": "use-cases-module__-aw63G__useCasesContainer",
});
